import { Outlet } from "react-router"
import Navigation from "../components/Navigation.js"
import Footer from "../components/Footer.js"
import CookieBanner from "../components/CookieBanner.js"

const RouterRoot = ({ text, settings, setSettings }) => {
    return (
        <div data-bs-theme={settings.dataBsTheme}>
            <header style={{ zIndex: 1000 }}>
                <Navigation text={text} settings={settings} setSettings={setSettings} />
            </header>
            <CookieBanner text={text} settings={settings} setSettings={setSettings} />
            <Outlet />
            <Footer text={text} settings={settings} />
        </div>
    )
}

export default RouterRoot
